enum Permission {
  VIEW_ALL_USERS = "VIEW_ALL_USERS",
  ADD_UPDATE_USER = "ADD_UPDATE_USER",
  ADD_UPDATE_MACHINES = "ADD_UPDATE_MACHINES",
  VIEW_ALL_MACHINES = "VIEW_ALL_MACHINES",
  GET_PORTAL_SUMMARY_COUNT = "GET_PORTAL_SUMMARY_COUNT",
  VIEW_ALL_RUNS = "VIEW_ALL_RUNS",
  VIEW_MACHINE_SERVICE = "VIEW_MACHINE_SERVICE",
  ADD_UPDATE_MACHINE_SERVICE = "ADD_UPDATE_MACHINE_SERVICE",
  UPLOAD_MACHINE_LOG_FILE = "UPLOAD_MACHINE_LOG_FILE",
  DOWNLOAD_MACHINE_LOG_FILES = "DOWNLOAD_MACHINE_LOG_FILES",
  VIEW_SOFTWARE_PACKAGE = "VIEW_SOFTWARE_PACKAGE",
  DELETE_SOFTWARE_PACKAGE = "DELETE_SOFTWARE_PACKAGE",
  UPLOAD_SOFTWARE_PACKAGE = "UPLOAD_SOFTWARE_PACKAGE",
  UPDATE_SOFTWARE_PACKAGE = "UPDATE_SOFTWARE_PACKAGE",
  VIEW_ALL_AUDIT_LOGS = "VIEW_ALL_AUDIT_LOGS"
}

export default Permission;
